import { render, staticRenderFns } from "./EgiftConfirm.vue?vue&type=template&id=578e34de&"
import script from "./EgiftConfirm.vue?vue&type=script&lang=js&"
export * from "./EgiftConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports